// import React from 'react';
// import { Container, Row, Col, Button, Card, Carousel, Image } from 'react-bootstrap';
// import { FaRocket, FaChalkboardTeacher, FaUsers, FaTrophy, FaSearch, FaPlay, FaChartLine, FaClipboardList, FaLinkedin, FaTwitter, FaFacebook, FaQuoteLeft } from 'react-icons/fa';
// import Elogo from '../Images/Elogoq.png'; // Replace with your actual logo path
// import qiz3 from '../Images/qiz3.jpg';
// import { Link, useNavigate } from 'react-router-dom';

// import './LandingPage.css'; // Add your custom styles here
// import { useState } from 'react';
// import { useEffect } from 'react';
// import axios from 'axios';

// const LandingPage = () => {

//   const [showJoinModal, setShowJoinModal] = useState(false);
//   const [joinStep, setJoinStep] = useState(1); // 1 = Enter PIN, 2 = Enter Details
//   const [gamePin, setGamePin] = useState('');
//   const [playerInfo, setPlayerInfo] = useState({ name: '', email: '', mobile: '' });
//   const navigate = useNavigate();
//   const [hostUserId, setHostUserId] = useState(null);
//   const [activeEventId, setActiveEventId] = useState(null);

//   // Color theme variables for consistent styling
//   const brandColors = {
//     orange: '#f35018',
//     blue: '#2f3194',
//     cyan: '#63decc',
//     darkBg: '#0f1137'
//   };

//   // Automatically parse URL parameters if participant scans the QR code

//   // Automatically parse URL parameters if participant scans the QR code vector instance
// useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const urlPin = params.get('pin');
//     const urlEventId = params.get('eventId');
    
//     if (urlPin) {
//       setGamePin(urlPin);
//       setShowJoinModal(true);
//       setJoinStep(2); // Jump directly to profile compilation
//     }
//     if (urlEventId) {
//       setActiveEventId(urlEventId);
//     }
//   }, [window.location.search]);

// // Updated verification function to check PIN state in backend database
// const handleVerifyPin = async (e) => {
//     e.preventDefault();
    
//     if (gamePin.length !== 6) {
//       alert("Please enter a valid 6-digit numeric PIN sequence.");
//       return;
//     }

//     try {
//       // Hit active Express verification route endpoint layout
//       const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${gamePin}`);
      
//       if (response.data.valid) {
//         // Access code is matching! Save tracking states and advance form
//         setHostUserId(response.data.userId);
//         setActiveEventId(response.data.eventId); // Saves event ID context safely
//         setJoinStep(2);
//       }
//     } catch (error) {
//       console.error("Verification breakdown query error:", error);
//       alert(error.response?.data?.message || "This game PIN is invalid or the session has ended.");
//     }
//   };

//   const handleJoinGameSubmit = async (e) => {
//     e.preventDefault();
//     if (!playerInfo.name || !playerInfo.email || !playerInfo.mobile) {
//       alert("Please fill in all parameters.");
//       return;
//     }

//     try {
//       // HIT REGISTRATION API PASSING PARAMETERS FOR HISTORICAL ROUTING PRESERVATION
//       const response = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/register-participant', {
//         name: playerInfo.name,
//         email: playerInfo.email,
//         mobile: playerInfo.mobile,
//         userId: hostUserId,
//         eventId: activeEventId, // This variable is now declared and active
//         roomPin: gamePin
//       });

//       if (response.data.success) {
//         // Route participants cleanly straight down to the master arena path
//         navigate(`/PlayerRoom/${gamePin}`, {
//           state: {
//             pin: gamePin,
//             name: playerInfo.name,
//             email: playerInfo.email,
//             mobile: playerInfo.mobile,
//             participantId: response.data.participantId
//           }
//         });
//       }
//     } catch (error) {
//       console.error("Registration operational error:", error);
//       alert("Failed to create user session profile records. Try again.");
//     }
//   };


//   return (
//   <div className="landing-page">
//       <header className="header">
//         <div className="header-container">
//           <img src={Elogo} alt="eMedha Technologies Logo" className="logo" />
//           <div style={{
//             fontFamily: 'Arial, sans-serif',
//             fontSize: '50px',
//             fontWeight: 'bold',
//             color: '#fff',
//             background: 'linear-gradient(to right, #3498db, #8e44ad)',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             marginBottom: '15px',
//             textTransform: 'uppercase',
//             letterSpacing: '2px',
//             textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
//           }} >
//             QuizifyAI
//           </div>
//           <h1 className="header-title">Unlock the Power of AI-Driven Quizzes</h1>
//           <p className="header-subtitle mb-3" style={{ color: '#fff' }}>
//             Take your learning and assessment experience to the next level! Try our smart, adaptive, and engaging quizzes powered by cutting-edge artificial intelligence.
//           </p>
          
//           {/* UPDATED CTA SECTIONS INCLUDING THE JOIN FLOW */}
//           <div className="cta-buttons d-flex flex-wrap gap-2 justify-content-center align-items-center">
//             <Button 
//               onClick={() => { setJoinStep(1); setShowJoinModal(true); }}
//               size="lg" 
//               className="cta-button fw-bold transition-all px-4" 
//               style={{ backgroundColor: brandColors.orange, border: 'none', borderRadius: '12px', boxShadow: '0 8px 20px rgba(243,80,24,0.25)' }}
//             >
//               🎮 Join Live Game
//             </Button>

//             <Button variant="primary" size="lg" className="cta-button" style={{ backgroundColor: "#003b6d", borderRadius: '12px' }}>
//               <Link to="/login" style={{ color: 'inherit', textDecoration: 'none' }}>
//                 Start Now
//               </Link>
//             </Button>

//             <Button variant="outline-light" size="lg" className="cta-button" style={{ borderRadius: '12px' }}>
//               <Link to="/login" style={{ color: 'inherit', textDecoration: 'none' }}>
//                 Try a Demo Quiz
//               </Link>
//             </Button>
//           </div>
//         </div>
//       </header>


//       <section className="features">
//         <Container>
//           <h2 className="section-title">Feature Highlights</h2>
//           <Row className="feature-cards">
//             <Col xs={12} sm={6} md={3} className="feature-item">
//               <FaRocket size={50} color="#0067b8" />
//               <h3>Personalized Quizzes</h3>
//               <p>Our AI curates questions tailored to your skill level, interests, and learning pace.</p>
//             </Col>
//             <Col xs={12} sm={6} md={3} className="feature-item">
//               <FaChalkboardTeacher size={50} color="#0067b8" />
//               <h3>Instant Feedback</h3>
//               <p>Receive real-time explanations and performance analytics to track your progress instantly.</p>
//             </Col>
//             <Col xs={12} sm={6} md={3} className="feature-item">
//               <FaUsers size={50} color="#0067b8" />
//               <h3>Wide Range of Subjects</h3>
//               <p>Explore quizzes covering academics, competitive exams, corporate skills, and more!</p>
//             </Col>
//             <Col xs={12} sm={6} md={3} className="feature-item">
//               <FaTrophy size={50} color="#0067b8" />
//               <h3>Challenge Friends & Colleagues</h3>
//               <p>Invite others for friendly competitions, group assessments, or leaderboard challenges.</p>
//             </Col>
//           </Row>
//         </Container>
//       </section>


//       <section className="how-it-works">
//         <Container>
//           <h2 className="section-title">How It Works</h2>
//           <Row className="how-it-works-row">
//             {/* Left Side: Quiz Image */}


//             {/* Right Side: Carousel with Shadow Cards */}
//             <Col xs={12} md={6} className="carousel-side">
//               <Carousel interval={3000} fade={true} indicators={true} controls={true}>
//                 <Carousel.Item>
//                   <div className="carousel-content">
//                     <FaSearch size={70} color="#fff" className="carousel-icon" />
//                     <h3>Pick a Quiz or Topic</h3>
//                     <p>Choose from our vast library or let the AI recommend one for you.</p>
//                   </div>
//                 </Carousel.Item>
//                 <Carousel.Item>
//                   <div className="carousel-content">
//                     <FaPlay size={70} color="#fff" className="carousel-icon" />
//                     <h3>Start Quiz</h3>
//                     <p>Engage with interactive, dynamic questions tailored to your profile.</p>
//                   </div>
//                 </Carousel.Item>
//                 <Carousel.Item>
//                   <div className="carousel-content">
//                     <FaClipboardList size={70} color="#fff" className="carousel-icon" />
//                     <h3>Get Results Instantly</h3>
//                     <p>Review personalized feedback, strengths, and improvement tips.</p>
//                   </div>
//                 </Carousel.Item>
//                 <Carousel.Item>
//                   <div className="carousel-content">
//                     <FaChartLine size={70} color="#fff" className="carousel-icon" />
//                     <h3>Track Your Progress</h3>
//                     <p>Access detailed analytics over time to gauge your mastery.</p>
//                   </div>
//                 </Carousel.Item>
//               </Carousel>
//             </Col>

//             <Col xs={12} md={5} className="image-side">
//               <img src={qiz3} alt="Quiz Illustration" className="quiz-image" />
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       <section className="who-it-for">
//         <Container>
//           <h2 className="section-title" style={{ color: '#003b6d' }}>Who is it for?</h2>
//           <Row className="who-items">
//             <Col xs={12} sm={6} md={4} className="who-item-col">

//               <FaUsers size={70} color="#fff" className="who-icon" />
//               <h4>Students & Learners</h4>
//               <p>Master your subjects with engaging quizzes designed to enhance your learning.</p>

//             </Col>
//             <Col xs={12} sm={6} md={4} className="who-item-col">

//               <FaChalkboardTeacher size={70} color="#fff" className="who-icon" />
//               <h4>Educators & Trainers</h4>
//               <p>Empower your teaching with AI-driven quizzes and real-time feedback.</p>

//             </Col>
//             <Col xs={12} sm={6} md={4} className="who-item-col">

//               <FaTrophy size={70} color="#fff" className="who-icon" />
//               <h4>Competitive Exam Aspirants</h4>
//               <p>Boost your preparation with personalized quizzes designed for exam success.</p>

//             </Col>
//           </Row>
//         </Container>
//       </section>



//       <section className="testimonials">
//         <Container>
//           <h2 className="section-title">What Our Users Are Saying</h2>
//           <Carousel interval={5000} controls={true} indicators={true} fade={true}>
//             <Carousel.Item>
//               <div className="testimonial-card">
//                 <FaQuoteLeft size={40} color="#00b5e2" className="quote-icon" />
//                 <blockquote>
//                   "AI Quiz Master helped me prep efficiently for my college entrance exams. The adaptive quizzes kept me engaged and motivated!"
//                   <footer>- Priya S., Hyderabad</footer>
//                 </blockquote>
//               </div>
//             </Carousel.Item>
//             <Carousel.Item>
//               <div className="testimonial-card">
//                 <FaQuoteLeft size={40} color="#00b5e2" className="quote-icon" />
//                 <blockquote>
//                   "Loved the instant analytics and feedback. Great for our office team-building sessions!"
//                   <footer>- Rohit M., Bangalore</footer>
//                 </blockquote>
//               </div>
//             </Carousel.Item>
//             <Carousel.Item>
//               <div className="testimonial-card">
//                 <FaQuoteLeft size={40} color="#00b5e2" className="quote-icon" />
//                 <blockquote>
//                   "The quizzes were personalized and helped me focus on my weak areas. It's a game-changer for exam prep."
//                   <footer>- Sandeep K., Delhi</footer>
//                 </blockquote>
//               </div>
//             </Carousel.Item>
//           </Carousel>
//         </Container>
//       </section>




//       <section className="cta">
//         <Container>
//           <h2>Ready to master your knowledge with the power of AI?</h2>
//           <div className="cta-buttons">
//             <Button variant="primary" size="lg" className="cta-button">
//               <Link to="/login" style={{ color: 'inherit', textDecoration: 'none' }}>
//                 Get Started Free
//               </Link>
//             </Button>
//             <Button variant="secondary" size="lg" className="cta-button">
//               <Link to="/login" style={{ color: 'inherit', textDecoration: 'none' }}>
//                 Browse Quiz
//               </Link>

//             </Button>
//           </div>
//         </Container>
//       </section>


//       <footer className="footer">
//         <Container>
//           <p>QuizifyAI.in – Smart Quizzes, Smarter You.</p>
//           <div className="social-links">
//             <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
//               <FaLinkedin size={30} color="#ffffff" />
//             </a>
//             <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
//               <FaTwitter size={30} color="#ffffff" />
//             </a>
//             <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
//               <FaFacebook size={30} color="#ffffff" />
//             </a>
//           </div>
//           <p className="copyright">© 2025 Quizifyai. All rights reserved.</p>
//         </Container>
//       </footer>
// {/* MULTI-STEP GAME JOIN OVERLAY INFRASTRUCTURE */}
//       {showJoinModal && (
//         <div style={{
//           position: 'fixed',
//           top: 0, left: 0, right: 0, bottom: 0,
//           backgroundColor: 'rgba(15, 17, 55, 0.7)',
//           backdropFilter: 'blur(12px)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 9999,
//           padding: '20px'
//         }}>
//           <div style={{
//             backgroundColor: '#ffffff',
//             maxWidth: '460px',
//             width: '100%',
//             borderRadius: '24px',
//             padding: '35px',
//             boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2)',
//             border: '1px solid rgba(255, 255, 255, 0.8)',
//             position: 'relative'
//           }}>
//             {/* Close Toggle Button */}
//             <button 
//               onClick={() => setShowJoinModal(false)}
//               style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', fontSize: '20px', color: '#a0a5ba', cursor: 'pointer' }}
//             >
//               ✕
//             </button>

//             {/* STEP 1: NUMERIC GAME PIN ENTRY */}
//             {joinStep === 1 && (
//               <form onSubmit={handleVerifyPin} className="text-center">
//                 <div style={{ fontSize: '32px', marginBottom: '10px' }}>🕹️</div>
//                 <h4 className="fw-bold mb-2" style={{ color: brandColors.blue, letterSpacing: '-0.5px' }}>Enter Game PIN</h4>
//                 <p className="text-muted mb-4" style={{ fontSize: '13px' }}>Input the 6-digit session room number projected by the quiz administrator.</p>
                
//                 <input 
//                   type="text"
//                   maxLength={6}
//                   value={gamePin}
//                   onChange={(e) => setGamePin(e.target.value.replace(/\D/g, ''))} // Restricts inputs to numeric digits only
//                   placeholder="000000"
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '14px',
//                     borderRadius: '14px',
//                     border: '2px solid rgba(47, 49, 148, 0.1)',
//                     fontSize: '28px',
//                     fontWeight: '800',
//                     textAlign: 'center',
//                     letterSpacing: '6px',
//                     color: brandColors.blue,
//                     backgroundColor: '#f8f9fc',
//                     marginBottom: '20px'
//                   }}
//                 />

//                 <button 
//                   type="submit" 
//                   className="btn w-100 fw-bold py-3 text-white"
//                   style={{ background: brandColors.blue, borderRadius: '12px', fontSize: '14px', border: 'none' }}
//                 >
//                   Verify Access Code
//                 </button>
//               </form>
//             )}

//             {/* STEP 2: PARTICIPANT DATA PROFILE COLLECTION */}
//             {joinStep === 2 && (
//               <form onSubmit={handleJoinGameSubmit}>
//                 <div className="text-center mb-4">
//                   <span className="badge px-3 py-2 rounded-pill mb-2" style={{ backgroundColor: 'rgba(243, 80, 24, 0.08)', color: brandColors.orange, fontSize: '11px', fontWeight: '600' }}>
//                     Room Connected: {gamePin}
//                   </span>
//                   <h4 className="fw-bold m-0" style={{ color: brandColors.blue, letterSpacing: '-0.5px' }}>Complete Player Profile</h4>
//                   <p className="text-muted mb-0" style={{ fontSize: '12px' }}>Please configure your details to join the active ranking board.</p>
//                 </div>

//                 {/* Full Name Field */}
//                 <div className="mb-3">
//                   <label className="fw-bold text-muted mb-1 d-block" style={{ fontSize: '11px' }}>FULL NAME / NICKNAME</label>
//                   <input 
//                     type="text" 
//                     required 
//                     placeholder="Enter your name"
//                     className="form-control px-3 py-2"
//                     value={playerInfo.name}
//                     onChange={(e) => setPlayerInfo({ ...playerInfo, name: e.target.value })}
//                     style={{ borderRadius: '10px', fontSize: '13px', border: '1px solid rgba(47, 49, 148, 0.15)' }}
//                   />
//                 </div>

//                 {/* Email Field */}
//                 <div className="mb-3">
//                   <label className="fw-bold text-muted mb-1 d-block" style={{ fontSize: '11px' }}>EMAIL ADDRESS</label>
//                   <input 
//                     type="email" 
//                     required 
//                     placeholder="name@company.com"
//                     className="form-control px-3 py-2"
//                     value={playerInfo.email}
//                     onChange={(e) => setPlayerInfo({ ...playerInfo, email: e.target.value })}
//                     style={{ borderRadius: '10px', fontSize: '13px', border: '1px solid rgba(47, 49, 148, 0.15)' }}
//                   />
//                 </div>

//                 {/* Mobile Field */}
//                 <div className="mb-4">
//                   <label className="fw-bold text-muted mb-1 d-block" style={{ fontSize: '11px' }}>MOBILE NUMBER</label>
//                   <input 
//                     type="tel" 
//                     required 
//                     placeholder="Enter 10-digit number"
//                     className="form-control px-3 py-2"
//                     value={playerInfo.mobile}
//                     onChange={(e) => setPlayerInfo({ ...playerInfo, mobile: e.target.value })}
//                     style={{ borderRadius: '10px', fontSize: '13px', border: '1px solid rgba(47, 49, 148, 0.15)' }}
//                   />
//                 </div>

//                 {/* Navigation Triggers */}
//                 <div className="d-flex gap-2">
//                   <button 
//                     type="button"
//                     className="btn fw-semibold py-2 px-3"
//                     onClick={() => setJoinStep(1)}
//                     style={{ background: '#f0f2f5', borderRadius: '12px', fontSize: '13px', border: 'none', color: brandColors.darkBg }}
//                   >
//                     Back
//                   </button>
//                   <button 
//                     type="submit" 
//                     className="btn flex-grow-1 fw-bold py-2 text-white"
//                     style={{ background: `linear-gradient(135deg, ${brandColors.orange}, #ff7342)`, borderRadius: '12px', fontSize: '13px', border: 'none' }}
//                   >
//                     Enter Live Arena 🚀
//                   </button>
//                 </div>
//               </form>
//             )}

//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LandingPage;


import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { 
  FaRocket, FaChalkboardTeacher, FaUsers, FaTrophy, FaSearch, 
  FaPlay, FaChartLine, FaClipboardList, FaLinkedin, FaTwitter, 
  FaFacebook, FaQuoteLeft, FaCheck, FaCrown, FaStar, FaArrowRight,
  FaBolt, FaShieldAlt, FaGamepad,
  FaGift,
  FaCheckCircle,
  FaAward
} from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import Elogo from '../Images/Elogoq.png'; 
import qiz3 from '../Images/qiz3.jpg';
import './LandingPage.css';


const brand = {
    navyDeep: '#0f1137',
    navyAccent: '#2f3194',
    orange: '#f35018',
    orangeHover: '#d84310',
    cyan: '#0d9488',
    cyanLight: '#ccfbf1',
    emerald: '#059669',
  };

const LandingPage = () => {
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [joinStep, setJoinStep] = useState(1);
  const [gamePin, setGamePin] = useState('');
  const [playerInfo, setPlayerInfo] = useState({ name: '', email: '', mobile: '' });
  const [hostUserId, setHostUserId] = useState(null);
  const [activeEventId, setActiveEventId] = useState(null);
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [isLoading, setIsLoading] = useState(false);

  const [regTab, setRegTab] = useState('new'); // 'new' | 'returning'
  const [loginMobile, setLoginMobile] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const [maxAllowedPlayers, setMaxAllowedPlayers] = useState(100);

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlPin = params.get('pin');
    const urlEventId = params.get('eventId');
    
    if (urlPin) {
      setGamePin(urlPin);
      setShowJoinModal(true);
      setJoinStep(2);
    }
    if (urlEventId) {
      setActiveEventId(urlEventId);
    }
  }, []);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlPin = params.get('pin');
    const urlEventId = params.get('eventId');
    
    if (urlPin) {
      setGamePin(urlPin);
      if (urlEventId) setActiveEventId(urlEventId);

      // Auto-fetch host and room capacity
      axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${urlPin}`)
        .then((res) => {
          if (res.data.valid) {
            setHostUserId(res.data.userId);
            setActiveEventId(res.data.eventId);
            if (res.data.maxParticipants !== undefined) {
              setMaxAllowedPlayers(res.data.maxParticipants);
            }
            setJoinStep(2);
            setShowJoinModal(true);
          }
        })
        .catch(() => {
          setJoinStep(1);
          setShowJoinModal(true);
        });
    }
  }, []);


  const handleVerifyPin = async (e) => {
    if (e) e.preventDefault();
    if (gamePin.trim().length !== 6) {
      alert("Please enter a valid 6-digit numeric PIN.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${gamePin}`);
      if (response.data.valid) {
        setHostUserId(response.data.userId);
        setActiveEventId(response.data.eventId);

   if (response.data.maxParticipants !== undefined) {
          setMaxAllowedPlayers(response.data.maxParticipants);
        }

        setRegTab('new');
        setLoginMobile('');
             setJoinStep(2);
        setShowJoinModal(true);
      }
    } catch (error) {
      console.error("Verification error:", error);
      alert(error.response?.data?.message || "This game PIN is invalid or the session has ended.");
    } finally {
      setIsLoading(false);
    }
  };



  const handleReturningLogin = async (e) => {
    e.preventDefault();
    if (!loginMobile.trim()) {
      alert("Please enter your registered mobile number.");
      return;
    }

    setIsLoggingIn(true);
    try {
      const res = await axios.get(
        `https://rvapi.emedha.in/pages/api/api/quiz/check-registered-player/${gamePin}/${loginMobile.trim()}`
      );

      if (res.data?.registered) {
        const player = res.data.player;
        navigate(`/PlayerRoom/${gamePin}`, {
          state: {
            pin: gamePin,
            name: player.name,
            email: player.email,
            mobile: player.mobile,
            participantId: player.id
          }
        });
      } else {
        alert("No registration found with this mobile number for this PIN. Please switch to New Registration.");
        setRegTab('new');
        setPlayerInfo(prev => ({ ...prev, mobile: loginMobile.trim() }));
      }
    } catch (err) {
      console.error("Login verification failed:", err);
      alert(err.response?.data?.message || "Failed to verify registration. Please try again.");
    } finally {
      setIsLoggingIn(false);
    }
  };



  const handleJoinGameSubmit = async (e) => {
    e.preventDefault();
    if (!playerInfo.name || !playerInfo.email || !playerInfo.mobile) {
      alert("Please fill in all player details.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/register-participant', {
        name: playerInfo.name,
        email: playerInfo.email,
        mobile: playerInfo.mobile,
        userId: hostUserId,
        eventId: activeEventId,
        roomPin: gamePin
      });

      if (response.data.success) {
        navigate(`/PlayerRoom/${gamePin}`, {
          state: {
            pin: gamePin,
            name: playerInfo.name,
            email: playerInfo.email,
            mobile: playerInfo.mobile,
            participantId: response.data.participantId
          }
        });
      }
    } catch (error) {
     console.error("Registration error:", error);
      const errorMsg = error.response?.data?.error || "Failed to join arena session. Please try again.";
      alert(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="premium-landing">
      {/* GLOW BACKGROUND EFFECT */}
      <div className="ambient-glow glow-top"></div>
      <div className="ambient-glow glow-right"></div>

      {/* TOP NAVBAR */}
      <nav className="site-navbar">
        <Container className="d-flex align-items-center justify-content-between">
       <div className="navbar-brand-group d-flex align-items-center gap-2">
  <div className="nav-logo-plate">
    <img src={Elogo} alt="QuizifyAI" className="nav-brand-logo" />
  </div>
  <span className="nav-brand-text">
    Quizify<span className="nav-brand-highlight">AI</span>
  </span>
</div>
          <div className="d-flex align-items-center gap-3">
            <Link to="/login" className="nav-link-item">Sign In</Link>
            <Link to="/login" className="btn-nav-primary">Host Live Game</Link>
          </div>
        </Container>
      </nav>

      {/* HERO SECTION */}
      <header className="hero-section">
        <Container>
          <div className="hero-content mx-auto text-center">
            <div className="hero-pill-badge mb-4">
              <FaBolt className="badge-icon-accent" />
              <span>Next-Gen Multiplayer Arena Engine</span>
            </div>

            <h1 className="hero-headline">
              Interactive Live Quizzing, <br />
              <span className="text-gradient">Supercharged by AI.</span>
            </h1>

            <p className="hero-subtext">
              Transform classrooms, corporate trainings, and summits into competitive, synchronized game shows with instant adaptive questions and automated verifiable certifications.
            </p>

            {/* INSTANT PIN ENTER DOCK */}
            <div className="hero-pin-card shadow-lg mx-auto">
              <div className="pin-dock-label">Have a game PIN? Join in seconds</div>
              <form onSubmit={handleVerifyPin} className="pin-input-group">
                <input 
                  type="text"
                  maxLength={6}
                  value={gamePin}
                  onChange={(e) => setGamePin(e.target.value.replace(/\D/g, ''))}
                  placeholder="Enter 6-digit PIN"
                  className="hero-pin-field"
                />
                <button type="submit" disabled={isLoading} className="btn-join-pin">
                  {isLoading ? 'Connecting...' : <>Join Game <FaArrowRight /></>}
                </button>
              </form>
            </div>

            <div className="hero-cta-secondary mt-4">
              <span>Looking to create or run your own quiz?</span>
              <Link to="/login" className="host-link-btn">Start Hosting Free</Link>
            </div>
          </div>
        </Container>
      </header>

      {/* METRIC STRIP */}
      <section className="metrics-strip">
        <Container>
          <Row className="g-4 text-center">
            <Col xs={6} md={3}>
              <div className="metric-box">
                <h3>99.9%</h3>
                <p>Sync Uptime</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="metric-box">
                <h3>&lt; 50ms</h3>
                <p>Real-Time Latency</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="metric-box">
                <h3>1000+</h3>
                <p>Quizzes Completed</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="metric-box">
                <h3>Instant</h3>
                <p>Certificate Delivery</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CORE FEATURES SECTION */}
      <section className="features-section">
        <Container>
          <div className="section-header text-center">
            <span className="section-pill">Why QuizifyAI</span>
            <h2 className="section-heading">Engineered for High-Stakes Engagement</h2>
            <p className="section-subheading">Everything you need to orchestrate live multiplayer sessions with complete administrative control.</p>
          </div>

          <Row className="g-4">
            <Col xs={12} sm={6} lg={3}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <FaRocket />
                </div>
                <h4>AI Adaptive Banks</h4>
                <p>Instantly generate question clusters tuned to dynamic difficulty levels, topics, or uploaded syllabi.</p>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <FaChalkboardTeacher />
                </div>
                <h4>Podium Analytics</h4>
                <p>Deep real-time insight into speed, accuracy drop-offs, and competitive podium progression.</p>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <FaUsers />
                </div>
                <h4>Low-Bandwidth Rooms</h4>
                <p>Smooth, low-latency performance even across cellular connections and massive simultaneous cohorts.</p>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <FaTrophy />
                </div>
                <h4>Auto E-Certificates</h4>
                <p>Dispatch verifiable, digitally signed completion certificates straight to attendee inboxes on session close.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* HOW IT WORKS DUAL SECTION */}
     {/* HOW LIVE ARENA OPERATES - INTERACTIVE PROGRESSION UI */}
<section className="workflow-section py-5">
  <Container>
    <div className="section-header text-center mb-5">
      <span className="section-pill">Interactive Architecture</span>
      <h2 className="section-heading">How Live Arena Operates</h2>
      <p className="section-subheading">
        Three streamlined steps from AI generation to podium victory and automatic certification.
      </p>
    </div>

    <Row className="g-4 align-items-center">
      {/* LEFT: STEP-BY-STEP PROGRESSION TILES */}
      <Col xs={12} lg={6}>
        <div className="steps-container d-flex flex-column gap-3">
          
          <div className="step-card active">
            <div className="step-badge-number">01</div>
            <div className="step-info">
              <h4>Generate or Select Challenge</h4>
              <p>
                Provide syllabus keywords, prompt the AI engine, or pull pre-built assessments straight into your host console.
              </p>
              <div className="step-tags">
                <span>AI Auto-Gen</span>
                <span>Custom Question Banks</span>
              </div>
            </div>
          </div>

          <div className="step-card">
            <div className="step-badge-number">02</div>
            <div className="step-info">
              <h4>Stream PIN &amp; Synchronize Players</h4>
              <p>
                Broadcast your unique 6-digit access code or QR code on screens. Players jump straight in from any browser.
              </p>
              <div className="step-tags">
                <span>Zero App Installs</span>
                <span>Low Latency Socket</span>
              </div>
            </div>
          </div>

          <div className="step-card">
            <div className="step-badge-number">03</div>
            <div className="step-info">
              <h4>Live Podium &amp; Instant E-Certificates</h4>
              <p>
                Watch real-time streaks and rank flips after every prompt. Auto-dispatch signed completion awards at session close.
              </p>
              <div className="step-tags">
                <span>Instant Leaderboard</span>
                <span>Automated Email Dispatch</span>
              </div>
            </div>
          </div>

        </div>
      </Col>

      {/* RIGHT: LIVE ARENA SIMULATED DISPLAY */}
      <Col xs={12} lg={6}>
        <div className="arena-mockup-wrapper">
          <div className="arena-mockup-header">
            <div className="mockup-dots">
              <span></span><span></span><span></span>
            </div>
            <div className="mockup-session-pill">
              <span className="live-pulse-dot"></span> LIVE ARENA #482910
            </div>
          </div>

          <div className="arena-mockup-body">
            {/* QUESTION DISPLAY */}
            <div className="mockup-timer-bar">
              <div className="mockup-timer-fill"></div>
            </div>
            
            <div className="mockup-question-box">
              <span className="question-round">Question 4 of 10</span>
              <h5>What is the primary advantage of AI-driven real-time quiz assessment?</h5>
            </div>

            {/* LIVE 4-CHOICE GRID (Kahoot Style) */}
            <div className="mockup-grid">
              <div className="grid-choice red">
                <span className="choice-symbol">▲</span> Instant Adaptive Scoring
              </div>
              <div className="grid-choice blue">
                <span className="choice-symbol">◆</span> Manual Paper Reviews
              </div>
              <div className="grid-choice yellow">
                <span className="choice-symbol">●</span> Delayed Certifications
              </div>
              <div className="grid-choice green">
                <span className="choice-symbol">■</span> Synchronized Analytics
              </div>
            </div>

            {/* LIVE STREAM PODIUM PREVIEW */}
            <div className="mockup-footer-stats">
              <div className="stat-item">
                <strong>142</strong>
                <span>Players Online</span>
              </div>
              <div className="stat-item">
                <strong className="text-warning">94%</strong>
                <span>Response Rate</span>
              </div>
              <div className="stat-item">
                <strong className="text-success">Rank 1:</strong>
                <span>Priya S(3,840 pts)</span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
</section>

      {/* PRICING SECTION */}
      <section className="pricing-section">
        <Container>
          <div className="section-header text-center">
            <span className="section-pill">Pricing</span>
            <h2 className="section-heading">Plans Scaled to Your Audience</h2>
            <p className="section-subheading">Predictable subscriptions for tutors, academies, and enterprise organizers.</p>

            <div className="pricing-toggle-box mt-4">
              <button 
                type="button"
                className={`toggle-btn ${billingCycle === 'monthly' ? 'active' : ''}`}
                onClick={() => setBillingCycle('monthly')}
              >
                Monthly
              </button>
              <button 
                type="button"
                className={`toggle-btn ${billingCycle === 'annual' ? 'active' : ''}`}
                onClick={() => setBillingCycle('annual')}
              >
                Annual <span className="discount-tag">Save Up to 20%</span>
              </button>
            </div>
          </div>

   <Container fluid className="px-lg-3" style={{ maxWidth: '1640px' }}>
<div 
      className="position-relative overflow-hidden p-3 p-md-4 mb-5 rounded-4 mx-auto"
      style={{
        maxWidth: '1020px',
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 255, 0.95) 50%, rgba(240, 253, 250, 0.95) 100%)',
        border: '1.5px solid rgba(47, 49, 148, 0.14)',
        boxShadow: '0 20px 45px -15px rgba(15, 17, 55, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.8) inset',
        backdropFilter: 'blur(16px)',
      }}
    >
      {/* Brand Ambient Aura Top-Right (Cyan Glow) */}
      <div 
        style={{
          position: 'absolute',
          top: '-60px',
          right: '-50px',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(99, 222, 204, 0.35) 0%, rgba(255, 255, 255, 0) 70%)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      {/* Brand Ambient Aura Bottom-Left (Navy Glow) */}
      <div 
        style={{
          position: 'absolute',
          bottom: '-70px',
          left: '-40px',
          width: '220px',
          height: '220px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(47, 49, 148, 0.12) 0%, rgba(255, 255, 255, 0) 70%)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      <div className="position-relative d-flex flex-column flex-lg-row align-items-center justify-content-between gap-4" style={{ zIndex: 1 }}>
        
        {/* Left Side: Offer Hierarchy & Value Props */}
        <div className="text-center text-lg-start" style={{ flex: '1 1 auto' }}>
          
          {/* Header Pill with Live Pulse Dot */}
          <div 
            className="d-inline-flex align-items-center gap-2 px-3 py-1.5 rounded-pill mb-3 shadow-xs"
            style={{
              backgroundColor: '#fff',
              border: '1px solid rgba(13, 148, 136, 0.25)',
              boxShadow: '0 2px 8px rgba(13, 148, 136, 0.08)',
            }}
          >
            <span 
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: brand.emerald,
                boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.25)',
                display: 'inline-block',
              }}
            />
            <span style={{ fontSize: '11px', fontWeight: '800', color: brand.cyan, letterSpacing: '0.6px', textTransform: 'uppercase' }}>
              7-Day All-Access Host Pass
            </span>
            <span style={{ color: '#cbd5e1' }}>|</span>
            <span style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>
              Zero Upfront Cost
            </span>
          </div>

          {/* Heading */}
          <h3 
            className="fw-bold mb-2"
            style={{ 
              color: brand.navyDeep, 
              fontSize: '24px', 
              letterSpacing: '-0.5px',
              lineHeight: 1.25,
            }}
          >
            Launch Your Arena with Full AI Powers
          </h3>

          {/* Subtext */}
          <p 
            className="mb-4"
            style={{ 
              color: '#475569', 
              fontSize: '13.5px', 
              lineHeight: '1.55',
              maxWidth: '540px' 
            }}
          >
            Deliver real-time synchronized quizzes, automate evaluation vectors, and dispatch custom signed certificates straight to participant WhatsApp &amp; Inboxes.
          </p>

          {/* High-Impact Stat Tiles (Visual Quota Proofs) */}
          <div className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-2 pt-1">
            
            {/* Tile 1: Quizzes */}
            <div 
              className="d-flex align-items-center gap-2.5 px-3 py-2 rounded-3"
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid rgba(47, 49, 148, 0.1)',
                boxShadow: '0 2px 6px rgba(15, 17, 55, 0.04)',
              }}
            >
              <div 
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(47, 49, 148, 0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: brand.navyAccent,
                }}
              >
                <FaGamepad size={14} />
              </div>
              <div className="text-start">
                <span className="d-block fw-bold" style={{ fontSize: '12px', color: brand.navyDeep, lineHeight: 1.1 }}>
                  2 Quizzes
                </span>
                <small style={{ fontSize: '10.5px', color: '#64748b' }}>Live or Self-Paced</small>
              </div>
            </div>

            {/* Tile 2: Players */}
            <div 
              className="d-flex align-items-center gap-2.5 px-3 py-2 rounded-3"
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid rgba(13, 148, 136, 0.2)',
                boxShadow: '0 2px 6px rgba(13, 148, 136, 0.04)',
              }}
            >
              <div 
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '6px',
                  backgroundColor: brand.cyanLight,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: brand.cyan,
                }}
              >
                <FaUsers size={14} />
              </div>
              <div className="text-start">
                <span className="d-block fw-bold" style={{ fontSize: '12px', color: brand.navyDeep, lineHeight: 1.1 }}>
                  10 Players
                </span>
                <small style={{ fontSize: '10.5px', color: '#64748b' }}>Per Session Room</small>
              </div>
            </div>

            {/* Tile 3: Certifications */}
            <div 
              className="d-flex align-items-center gap-2.5 px-3 py-2 rounded-3"
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid rgba(243, 80, 24, 0.16)',
                boxShadow: '0 2px 6px rgba(243, 80, 24, 0.04)',
              }}
            >
              <div 
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '6px',
                  backgroundColor: 'rgba(243, 80, 24, 0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: brand.orange,
                }}
              >
                <FaAward size={14} />
              </div>
              <div className="text-start">
                <span className="d-block fw-bold" style={{ fontSize: '12px', color: brand.navyDeep, lineHeight: 1.1 }}>
                  Auto E-Certs
                </span>
                <small style={{ fontSize: '10.5px', color: '#64748b' }}>WhatsApp &amp; Email</small>
              </div>
            </div>

          </div>
        </div>

        {/* Right Side: High-Conversion CTA Dock */}
        <div 
          className="flex-shrink-0 d-flex flex-column align-items-center p-3 p-md-4 rounded-4"
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid rgba(47, 49, 148, 0.08)',
            boxShadow: '0 10px 25px -5px rgba(15, 17, 55, 0.06)',
            minWidth: '240px',
          }}
        >
          {/* Price Strike Tag */}
          <div className="text-center mb-2">
            <span style={{ fontSize: '11px', fontWeight: '700', color: '#94a3b8', textDecoration: 'line-through', marginRight: '6px' }}>
              ₹3,000 / mo
            </span>
            <span className="badge rounded-pill" style={{ backgroundColor: '#ecfdf5', color: brand.emerald, fontSize: '11px', fontWeight: '800' }}>
              100% FREE
            </span>
          </div>

          {/* Primary Action Button */}
          <Link
            to="/login"
            className="btn w-100 d-inline-flex align-items-center justify-content-center gap-2 px-4 py-2.5 rounded-3 fw-bold text-white"
            style={{
              backgroundColor: brand.orange,
              border: 'none',
              fontSize: '14px',
              letterSpacing: '0.2px',
              boxShadow: '0 6px 20px rgba(243, 80, 24, 0.35)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = brand.orangeHover;
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 24px rgba(243, 80, 24, 0.45)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = brand.orange;
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(243, 80, 24, 0.35)';
            }}
          >
            <FaBolt size={14} style={{ color: '#fed7aa' }} />
            <span>Start Free Trial</span>
            <FaArrowRight size={12} />
          </Link>

          {/* Trust Guarantees */}
        
        </div>

      </div>
    </div>
  <Row className="g-4 align-items-stretch justify-content-center">

    
    
    {/* TIER 1: BASIC */}
    <Col xs={12} md={6} lg={6} xl={3}>
      <div className="pricing-card-v2 basic-card h-100">
        <div className="card-top-header">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="tier-badge-pill basic-pill">Starter</span>
          </div>
          <h3 className="plan-title">Basic</h3>
          <p className="plan-subtitle">For individual educators &amp; small tutoring groups.</p>
        </div>

        <div className="price-plate">
          <div className="d-flex align-items-baseline">
            <span className="currency-symbol">₹</span>
            <span className="price-figure">{billingCycle === 'monthly' ? '3,000' : '28,800'}</span>
            <span className="billing-tenure">{billingCycle === 'monthly' ? '/month' : '/year'}</span>
          </div>
          {billingCycle === 'annual' && <span className="save-badge">Includes 20% discount</span>}
        </div>

        <div className="spec-chips-row">
          <span className="spec-chip"><strong>2</strong> Quizzes/mo</span>
          <span className="spec-chip"><strong>100</strong> Users/quiz</span>
        </div>

        <hr className="card-divider" />

        <ul className="perks-list-compact">
          <li><FaCheck className="perk-bullet" /> 1 Basic Certificate Template</li>
          <li><FaCheck className="perk-bullet" /> Live Leaderboard &amp; Speed Ranks</li>
          <li><FaCheck className="perk-bullet" /> In-browser participation (No app)</li>
          <li><FaCheck className="perk-bullet" /> WhatsApp/Email Score Delivery</li>
        </ul>

        <Link to="/login" className="btn-plan-action btn-plan-outline">Choose Basic</Link>
      </div>
    </Col>

    {/* TIER 2: SILVER */}
    <Col xs={12} md={6} lg={6} xl={3}>
      <div className="pricing-card-v2 silver-card h-100">
        <div className="card-top-header">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="tier-badge-pill silver-pill">Growth</span>
          </div>
          <h3 className="plan-title">Silver</h3>
          <p className="plan-subtitle">For competitive coaching centers &amp; departments.</p>
        </div>

        <div className="price-plate">
          <div className="d-flex align-items-baseline">
            <span className="currency-symbol">₹</span>
            <span className="price-figure">{billingCycle === 'monthly' ? '5,000' : '48,000'}</span>
            <span className="billing-tenure">{billingCycle === 'monthly' ? '/month' : '/year'}</span>
          </div>
          {billingCycle === 'annual' && <span className="save-badge">Includes 20% discount</span>}
        </div>

        <div className="spec-chips-row">
          <span className="spec-chip"><strong>5</strong> Quizzes/mo</span>
          <span className="spec-chip"><strong>100</strong> Users/quiz</span>
        </div>

        <hr className="card-divider" />

        <ul className="perks-list-compact">
          <li><FaCheck className="perk-bullet" /> 2 Designer Certificate Templates</li>
          <li><FaCheck className="perk-bullet" /> Bulk WhatsApp &amp; Email Dispatch</li>
          <li><FaCheck className="perk-bullet" /> Auto-Verification QR Codes</li>
          <li><FaCheck className="perk-bullet" /> Full Participant CSV Analytics</li>
        </ul>

        <Link to="/login" className="btn-plan-action btn-plan-outline">Choose Silver</Link>
      </div>
    </Col>

    {/* TIER 3: GOLD (FEATURED) */}
    <Col xs={12} md={6} lg={6} xl={3}>
      <div className="pricing-card-v2 gold-card featured-glow h-100">
        <div className="popular-banner">
          <FaStar className="me-1" /> Most Popular
        </div>

        <div className="card-top-header mt-2">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="tier-badge-pill gold-pill"><FaCrown className="me-1" /> Pro Tier</span>
          </div>
          <h3 className="plan-title text-gradient-gold">Gold</h3>
          <p className="plan-subtitle">For academies, colleges &amp; active summit hosts.</p>
        </div>

        <div className="price-plate">
          <div className="d-flex align-items-baseline">
            <span className="currency-symbol text-warning">₹</span>
            <span className="price-figure text-warning">{billingCycle === 'monthly' ? '7,500' : '72,000'}</span>
            <span className="billing-tenure">{billingCycle === 'monthly' ? '/month' : '/year'}</span>
          </div>
          {billingCycle === 'annual' && <span className="save-badge save-gold">Includes 20% discount</span>}
        </div>

        <div className="spec-chips-row">
          <span className="spec-chip gold-chip"><strong>10</strong> Quizzes/mo</span>
          <span className="spec-chip gold-chip"><strong>100</strong> Users/quiz</span>
        </div>

        <hr className="card-divider" />

        <ul className="perks-list-compact">
          <li><FaCheck className="perk-bullet text-warning" /> 3 Premium Certificate Templates</li>
          <li><FaCheck className="perk-bullet text-warning" /> Custom Host Branding &amp; Signature</li>
          <li><FaCheck className="perk-bullet text-warning" /> Live Podium &amp; Participant Tracking</li>
          <li><FaCheck className="perk-bullet text-warning" /> Detailed Accuracy Drop-off Logs</li>
        </ul>

        <Link to="/login" className="btn-plan-action btn-plan-primary">Choose Gold</Link>
      </div>
    </Col>

    {/* TIER 4: PLATINUM */}
    <Col xs={12} md={6} lg={6} xl={3}>
      <div className="pricing-card-v2 platinum-card h-100">
        <div className="card-top-header">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="tier-badge-pill platinum-pill"><FaTrophy className="me-1" /> Enterprise</span>
          </div>
          <h3 className="plan-title">Platinum</h3>
          <p className="plan-subtitle">Full scale for universities &amp; enterprise conventions.</p>
        </div>

        <div className="price-plate">
          <div className="d-flex align-items-baseline">
            <span className="currency-symbol">₹</span>
            <span className="price-figure">{billingCycle === 'monthly' ? '10,000' : '96,000'}</span>
            <span className="billing-tenure">{billingCycle === 'monthly' ? '/month' : '/year'}</span>
          </div>
          {billingCycle === 'annual' && <span className="save-badge">Includes 20% discount</span>}
        </div>

        <div className="spec-chips-row">
          <span className="spec-chip platinum-chip"><strong>20</strong> Quizzes/mo</span>
          <span className="spec-chip platinum-chip"><strong>Unlimited</strong>Users</span>
        </div>

        <hr className="card-divider" />

        <ul className="perks-list-compact">
          <li><FaCheck className="perk-bullet" /> 4 Custom Executive Templates</li>
          <li><FaCheck className="perk-bullet" /> Multi-Signer Avatars &amp; Signatures</li>
          <li><FaCheck className="perk-bullet" /> High-Concurrency Socket Priority</li>
          <li><FaCheck className="perk-bullet" /> Dedicated Account Manager &amp; SLA</li>
        </ul>

        <Link to="/login" className="btn-plan-action btn-plan-outline">Choose Platinum</Link>
      </div>
    </Col>

  </Row>
</Container>
        </Container>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials-section">
        <Container>
          <div className="section-header text-center">
            <span className="section-pill">Testimonials</span>
            <h2 className="section-heading">Trusted by Educators &amp; Organizers</h2>
          </div>

          <div className="testimonial-wrapper mx-auto">
            <Carousel interval={5000} indicators={true} controls={false} fade>
              <Carousel.Item>
                <div className="testimonial-glass-card">
                  <FaQuoteLeft className="quote-badge" />
                  <p className="quote-text">
                    "QuizifyAI completely transformed our college entrance preparation batches. The real-time adrenaline keeps every batch attentive."
                  </p>
                  <div className="quote-author">Priya S. — Hyderabad</div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="testimonial-glass-card">
                  <FaQuoteLeft className="quote-badge" />
                  <p className="quote-text">
                    "Instant certificate dispatch eliminated 3 days of manual work after our quarterly engineering hackathon. Flawless experience."
                  </p>
                  <div className="quote-author">Rohit M. — Bangalore</div>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
        </Container>
      </section>

      {/* BOTTOM CTA BANNER */}
      <section className="bottom-cta-section">
        <Container>
          <div className="cta-banner-card">
            <h2>Ready to Host Your First AI Quiz?</h2>
            <p>Set up an interactive multiplayer round in under 2 minutes. No credit card required.</p>
            <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">
              <Link to="/login" className="btn-banner-primary">Create Free Account</Link>
              <button onClick={() => { setJoinStep(1); setShowJoinModal(true); }} className="btn-banner-secondary">
                Join with PIN
              </button>
            </div>
          </div>
        </Container>
      </section>

      {/* FOOTER */}
<footer className="site-footer">
  <Container>
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 py-4 border-bottom border-white border-opacity-10">
      <div className="d-flex align-items-center gap-2">
        <img src={Elogo} alt="QuizifyAI" style={{ height: '32px' }} />
        <span className="fw-bold text-white fs-5">QuizifyAI</span>
      </div>
      <div className="social-links-row">
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
      </div>
    </div>
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3 gap-2">
      <span className="footer-visible-text">© 2026 QuizifyAI. All rights reserved.</span>
      <span className="footer-visible-subtext">Real-time Multiplayer Educational Assessment Engine</span>
    </div>
  </Container>
</footer>
      {/* JOIN GAME MODAL */}
      {showJoinModal && (
        <div className="join-modal-backdrop" onClick={() => setShowJoinModal(false)}>
          <div className="join-modal-card" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setShowJoinModal(false)} className="join-modal-close">✕</button>

            {joinStep === 1 && (
              <form onSubmit={handleVerifyPin} className="text-center">
                <div className="modal-icon-badge">🕹️</div>
                <h3 className="modal-title">Enter Game PIN</h3>
                <p className="modal-desc">Input the 6-digit session room code projected by your host.</p>

                <input 
                  type="text"
                  maxLength={6}
                  value={gamePin}
                  onChange={(e) => setGamePin(e.target.value.replace(/\D/g, ''))}
                  placeholder="000000"
                  required
                  autoFocus
                  className="modal-pin-input mb-4"
                />

                <button type="submit" disabled={isLoading} className="btn-modal-submit">
                  {isLoading ? 'Verifying...' : 'Verify Session Code'}
                </button>
              </form>
            )}

         {joinStep === 2 && (
              <div>
                <div className="text-center mb-3">
                <span className="room-connected-badge">
                    Connected: #{gamePin} &bull; Capacity: {maxAllowedPlayers === -1 ? 'Unlimited' : `${maxAllowedPlayers} Max`}
                  </span>
                  <h3 className="modal-title mt-2">Join Quiz Arena</h3>
                  <p className="modal-desc">Register or enter with your mobile number.</p>
                </div>

                {/* TAB SWITCHER */}
                <div 
                  className="d-flex p-1 rounded-3 mb-4" 
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.08)', border: '1px solid rgba(255, 255, 255, 0.15)' }}
                >
                  <button
                    type="button"
                    onClick={() => setRegTab('new')}
                    className="btn btn-sm w-50 fw-bold"
                    style={{
                      backgroundColor: regTab === 'new' ? '#f35018' : 'transparent',
                      color: '#ffffff',
                      borderRadius: '8px',
                      fontSize: '12px',
                      border: 'none',
                      padding: '8px 0',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    ✨ New Registration
                  </button>
                  <button
                    type="button"
                    onClick={() => setRegTab('returning')}
                    className="btn btn-sm w-50 fw-bold"
                    style={{
                      backgroundColor: regTab === 'returning' ? '#2f3194' : 'transparent',
                      color: '#ffffff',
                      borderRadius: '8px',
                      fontSize: '12px',
                      border: 'none',
                      padding: '8px 0',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    🔑 Already Registered
                  </button>
                </div>

                {/* TAB 1: NEW REGISTRATION FORM */}
                {regTab === 'new' && (
                  <form onSubmit={handleJoinGameSubmit}>
                    <div className="input-field-group mb-3 text-start">
                      <label className="text-white small fw-semibold mb-1">Full Name *</label>
                      <input 
                        type="text"
                        required
                        placeholder="e.g. Sivaji"
                        value={playerInfo.name}
                        onChange={(e) => setPlayerInfo({ ...playerInfo, name: e.target.value })}
                      />
                    </div>

                    <div className="input-field-group mb-3 text-start">
                      <label className="text-white small fw-semibold mb-1">Email Address (For Certificate) *</label>
                      <input 
                        type="email"
                        required
                        placeholder="name@domain.com"
                        value={playerInfo.email}
                        onChange={(e) => setPlayerInfo({ ...playerInfo, email: e.target.value })}
                      />
                    </div>

                    <div className="input-field-group mb-4 text-start">
                      <label className="text-white small fw-semibold mb-1">Mobile Number *</label>
                      <input 
                        type="tel"
                        required
                        placeholder="10-digit number"
                        value={playerInfo.mobile}
                        onChange={(e) => setPlayerInfo({ ...playerInfo, mobile: e.target.value })}
                      />
                    </div>

                    <div className="d-flex gap-2">
                      <button 
                        type="button" 
                        className="btn-modal-back"
                        onClick={() => setJoinStep(1)}
                      >
                        Back
                      </button>
                      <button type="submit" disabled={isLoading} className="btn-modal-submit flex-grow-1">
                        {isLoading ? 'Joining...' : 'Register & Enter 🚀'}
                      </button>
                    </div>
                  </form>
                )}

                {/* TAB 2: ALREADY REGISTERED (MOBILE ONLY) */}
                {regTab === 'returning' && (
                  <form onSubmit={handleReturningLogin}>
                    <p className="small mb-3 text-center" style={{ color: '#cbd5e1' }}>
                      Enter your pre-registered mobile number to join directly.
                    </p>

                    <div className="input-field-group mb-4 text-start">
                      <label className="text-white small fw-semibold mb-1">Registered Mobile Number *</label>
                      <input 
                        type="tel"
                        required
                        placeholder="e.g. 9876543210"
                        value={loginMobile}
                        onChange={(e) => setLoginMobile(e.target.value)}
                      />
                    </div>

                    <div className="d-flex gap-2">
                      <button 
                        type="button" 
                        className="btn-modal-back"
                        onClick={() => setJoinStep(1)}
                      >
                        Back
                      </button>
                      <button 
                        type="submit" 
                        disabled={isLoggingIn} 
                        className="btn-modal-submit flex-grow-1"
                        style={{ backgroundColor: '#2f3194' }}
                      >
                        {isLoggingIn ? 'Verifying...' : 'Verify & Enter Arena 🎮'}
                      </button>
                    </div>
                  </form>
                )}

              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;